<style scoped>
.table-title {
  font-size: 24px;
  margin: 40px 0 40px 15px;
}
</style>

<template>
  <v2-table :url="url" :headers="headers">
    <template slot="table-title">
      <div class="table-title">Dialoge</div>
    </template>
    <tr slot="row" slot-scope="{ item }">
      <td>
        <router-link :to="`/dialogkontrolle/${item.dialog_id}`">{{
          item.dialog_id
        }}</router-link>
      </td>
      <profile-cell
        :profile="item.fake"
        :message-count="item.fake_message_count"
      ></profile-cell>
      <td v-html="getDateTimeHtml(item.last_message_at)"></td>
    </tr>
  </v2-table>
</template>

<script>
import ProfileCell from "@/components/profile/Cell.vue";
import { getDateTimeHtml } from "@/js/date";

export default {
  components: {
    ProfileCell
  },
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      range: null,
      filter: "",
      getDateTimeHtml,
      headers: [
        {
          text: "ID"
        },
        {
          text: "Profil"
        },
        {
          text: "Letzte Nachricht"
        }
      ]
    };
  },
  computed: {
    url() {
      return `/api/v2/dialog?append=dialog_id&filter[fake_and_customer_profile_id]=${this.customer.id}&include=customer,fake&paginate`;
    }
  }
};
</script>
